<template lang="pug">
app-page(:fabItems="fabItems" title="Управление составами")
  app-toolbar(:title="'Составы категорий'") 

  app-empty-list(v-if="listGroupCategory.length == 0") Список пуст
  app-group-animation
    app-group-item(v-for="c in listGroupCategory" :key="c.id" cols="4")
      app-card(@click.native="moveGroupCategory(c)" data-aos="fade-top")
        app-card-header 
          app-card-title Состав - {{ c.name }}
        app-card-body
          app-card-caption(v-if="c.caseCategory.length > 0") Количество категорий в составе: {{ c.caseCategory.length }}
          app-card-caption(v-if="c.uCaseCategory && c.uCaseCategory.length > 0") Количество статей в составе: {{ c.uCaseCategory.length }}


  app-dialog(v-model="dialog.groupCategory" :header="'Карточка состава - ' + formGroup.name" :items="itemsGroup")
  app-dialog(v-model="dialog.groupCategoryAdd" :header="'Редактирование состава - ' + formGroup.name" @confirm="addGroupCategory()" confirmText="Добавить")
    app-text-field(v-model="formGroup.name" label="Название") 

  app-dialog-confirm(v-model="dialog.groupCategoryDel" @confirm="delGroupCategory(formGroup.id)")
    app-card-title.mt-5 Вы точно хотите удалить состав - {{ formGroup.name }} ?

</template>

<script>
import { caseService } from "@/_services";
import { AppDialogConfirm } from '@/components'

const groupCategoryDefault = {
  id:	'',
  name:	'',
  caseCategory:	[]
}

export default {
   components: {
    [AppDialogConfirm.name]: AppDialogConfirm
  },
  
  data () {
    return {
      listGroupCategory: [],
      dialog: {
        groupCategory: false,
        groupCategoryAdd: false,
        groupCategoryDel: false,
      },
      formGroup: groupCategoryDefault
    }
  },

  mounted () {
    this.loadGroupCategory()
  },

  computed: {
    fabItems () {
      return [
        { icon:'add', title:'Добавить состав', action: () => this.addNewGroup() },
      ]
    },

    itemsGroup () {
      return [
        { title: 'Редактировать', icon: 'edit', action: () => this.groupCategoryAdd() }, 
        { title: 'Добавить категорию в состав', icon: 'add', action: () => this.addCategory() }, 
        { title: 'Удалить', icon: 'delete', action: () => this.groupCategoryDel() }
      ]
    },
  },

  methods: {
    groupCategoryDel() {
      this.dialog.groupCategoryDel = true
    },
    groupCategoryAdd() {
      this.dialog.groupCategoryAdd = true
    },

    loadGroupCategory () {
      caseService.listGroupCategory()
      .then(data => {
        this.listGroupCategory = data
      })
    },

    addNewGroup () {
      console.log(1)
      this.formGroup = groupCategoryDefault
      this.dialog.groupCategoryAdd = true
    },

    addGroupCategory () {
      caseService.addGroupCategory(this.formGroup).then(() => this.loadGroupCategory())
    },

    moveGroupCategory(c) {
      if (c.uCaseCategory && c.uCaseCategory.length > 0) return false
      this.formGroup = c
      this.dialog.groupCategory = true
    },

    delGroupCategory (id) {
      caseService.delGroupCategory(id).then(() => this.loadGroupCategory())
    },

    addCategory () {
      this.$router.push({ path: `/admin/group/${this.formGroup.id}` })
    },
  }
}
</script>

<style scoped>

</style>


